import Vue from 'vue';
import trans from '~/plugins/trans-lib';

Vue.filter('trans', trans);

export default function (context) {
    context.app.methods.trans = trans;
    context.app.router.beforeEach(function (to, from, next) {
        global.selectedLang = to.params.lang;
        if (process.client) {
            if (to.params.lang == 'ar') {
                document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
            } else {
                document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
            }
        }
        next();
    });
}


//////////////////
// WEBPACK FOOTER
// ./plugins/trans-init.js
// module id = ./plugins/trans-init.js
// module chunks = 54